import { Fragment } from "react";
import { enqueueSnackbar } from "notistack";
import Grid from '@mui/material/Grid2';
import excelImage from "../../../../assets/images/excel_image.png";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { deleteFile, downloadFile, listExports } from "../../../../apis/apiExports";
import { Modal } from "react-bootstrap";
import { MCButton } from "../../../MainComponents";
import PasswordComponent from "./PasswordComment";
import { EthicsModal } from "../../../Modal/EthicsModal";
import { ButtonsControl, SmallCard } from "./Cards/Cards";

export const DetailExportables = ({
  lastFiles,
  areThereFiles,
  deleteFunction,
  updateFunctions,
  openModalFromDetail,
  selectedSection,
}) => {
  const [t] = useTranslation("exports");
  // This state is used to detect when a file was downloaded
  const [listDownloads, setListDownloads] = useState({});
  // This state is used to disable the download button
  const [selectedFile, setSelectedFile] = useState(null);
  // This state is used to disable the confirm delete excel file modal
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedAlias, setSelectedAlias] = useState('');

  const formatDates = (date) => {
    const objectDate = new Date(date);
    const day = objectDate.getDate();
    const month = objectDate.getMonth() + 1;
    const year = objectDate.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const handledownloadFile = async (alias) => {
    setSelectedFile(alias);
    enqueueSnackbar(`${t("Exports.downloading")}...`, { variant: "info" });

    const response = await downloadFile(alias);

    if (response !== undefined) {
      enqueueSnackbar(t("Exports.successfully_downloaded"), {
        variant: "success",
      });

      window.open(response.data.file, "_blank");

      setListDownloads((prevState) => ({
        ...prevState,
        [alias]: response.data,
      }));
    }

    setSelectedFile(null);
  };

  const handledeleteFile = async () => {
    setSelectedFile(selectedAlias);

    const response = await deleteFile(selectedAlias);

    if (response !== undefined) {
      enqueueSnackbar(t("Exports.successfully_deleted"), {
        variant: "success",
      });
    }
    setShowConfirmModal(false);
  };

  const handleConfirmDelete = async () => {
    await deleteFunction(selectedAlias);
    setShowConfirmModal(false);
  };

  const handleCancelDelete = () => {
    setShowConfirmModal(false);
  };

  const activateModal = (alias) => {
    setSelectedAlias(alias);
    setShowConfirmModal(true);
  };

  const generateComment = (item, size = 150) => {
    if (!item.comment) return (
      <>
        <span className="values comment">
          {t("Exports.no_comment")}
        </span>
      </>
    );

    if (item.comment.length > size) {

      const callbackComment = () => {
        openModalFromDetail(item, 'comment')
      };

      return (
        <>
          <span className="values comment">
            {item.comment.slice(0, size)}... <span className="detail" onClick={callbackComment}>{t("cards.more")}</span>
          </span>
        </>
      );
    };

    return (
      <>
        <span className="values comment">
          {item.comment}
        </span>
      </>
    );
  };

  const Confirm = () => {
    return (
      <>
        <Modal.Header closeButton>
          <h4>{t("Exports.delete_message")}</h4>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
            <MCButton
              label={t("Exports.cancel")}
              onClick={handleCancelDelete}
              variant="secondary"
            />
            <MCButton
              label={t("Exports.confirm")}
              onClick={handleConfirmDelete}
              variant="danger"
            />
          </div>
        </Modal.Body>
      </>

    )
  };

  const generateControl = (condition, arg1, arg2) => {

    return (
      <>
        {condition ? (
          <PasswordComponent
            password={arg1.password}
          />
        ) : (
          <ButtonsControl buttonsInformation={arg2} />
        )}
      </>
    );
  };

  return (
    <>
      <EthicsModal show={showConfirmModal} handleModal={() => setShowConfirmModal(!showConfirmModal)} modalContent={<Confirm />} />
      <Grid container spacing={2}>
        {lastFiles.map((item, index) => {
          const buttonsInformation = [
            {
              label: selectedFile !== item.alias ? t("buttons.download") : `${t("Exports.downloading")}...`,
              disabled: !item.is_recent,
              variant: 'success',
              onClick: () => handledownloadFile(item.alias),
            },
            {
              label: selectedFile !== item.alias ? t("buttons.info") : `${t("Exports.downloading")}...`,
              disabled: false,
              variant: 'info',
              onClick: () => openModalFromDetail(item, 'info'),
              style: {color: 'white'},
            },
            {
              label: selectedFile !== item.alias ? `${t("buttons.delete")}` : `${t("Exports.deleting")}...`,
              disabled: false,
              variant: 'danger',
              onClick: () => activateModal(item.alias),
              outline: true,
            },
          ]
          return (
            <Fragment key={item.alias}>
              <Grid size={12} className="container-rectangle-card">
                <SmallCard
                  item={item}
                  openModalFromDetail={openModalFromDetail}
                  controlsComponent={generateControl((item.alias in listDownloads), listDownloads[item.alias], buttonsInformation)}
                  title={item.kind === 'report' ? item.template__template_name : t(`section.${item.kind}`)}
                />
              </Grid>
              <Grid size={{ xs: 12, lg: 4 }} className="container-card">
                <div className="card">
                  <div className="card-body">
                    <img src={excelImage} alt="Excel" />
                    <div className="card-data">
                      <span className="labels">{ item.kind === 'report' ? `${t("Exports.template_name")}:` : `${t("Exports.kind_of_exportable")}:` }:</span>
                      <span
                        className="values cursor"
                        onClick={() => { openModalFromDetail(item, 'info') }}
                      >
                        {item.kind === 'report' ? item.template__template_name : t(`section.${item.kind}`)}
                      </span>
                      {generateComment(item, 85)}
                      <span className="values range-date">{item.range_date}</span>
                      <span className="labels">{t("Exports.created_at")}:</span>
                      <span className="values created-at">
                        {formatDates(item.created_at)}
                      </span>

                      {item.alias in listDownloads ? (
                        <PasswordComponent
                          password={listDownloads[item.alias].password}
                        />
                      ) : (
                        <>
                          <MCButton
                            label={
                              selectedFile !== item.alias
                                ? t("Exports.download")
                                : `${t("Exports.downloading")}...`
                            }
                            variant="success"
                            onClick={() => handledownloadFile(item.alias)}
                            disabled={selectedFile === item.alias || !item.is_recent}
                          />
                          <MCButton
                            style={{ marginTop: '12px' }}
                            label={
                              selectedFile !== item.alias
                                ? `${t("Exports.delete")}`
                                : `${t("Exports.deleting")}...`
                            }
                            outline
                            variant="danger"
                            onClick={() => activateModal(item.alias)}
                            disabled={selectedFile === item.alias}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
            </Fragment>
          )
        })}
      </Grid>
    </>
  );
};

export default DetailExportables;